/**
 * confirm_agreed label — use "entries are accurate" only when the form collects
 * free-text / phone / address input; acknowledgement-only forms get read-review wording.
 */

/** Forms where parents enter text, phone, or address (not checkbox-only consents). */
const FORMS_WITH_STRING_DATA_ENTRY = new Set([
  'form_07', 'form_08', 'form_09', 'form_10', 'form_14',
  'fa_03', 'fa_04', 'fa_05', 'fa_06', 'fa_11', 'fa_12', 'fa_16', 'fa_17',
  'wm_03', 'wm_04', 'wm_05', 'wm_07', 'wm_09', 'wm_10', 'wm_11', 'wm_12', 'wm_13',
]);

export function formHasStringDataEntry(formId) {
  return typeof formId === 'string' && FORMS_WITH_STRING_DATA_ENTRY.has(formId);
}

export function confirmAgreedLabel(formId) {
  if (formId === 'wm_10') {
    return 'I acknowledge the above information and will inform HASC of any changes.';
  }
  if (formId === 'wm_06') {
    return 'I acknowledge that remote learning and teletherapy services will be offered for my child.';
  }
  if (formId === 'fa_12' || formId === 'fa_16' || formId === 'fa_17') {
    return 'I have filled this out to the best of my ability.';
  }
  if (!formHasStringDataEntry(formId)) {
    return 'I have read and reviewed the information above';
  }
  return 'I have read the form above and confirm my entries are accurate';
}

export function confirmAgreedValidationMessage(formId) {
  if (formId === 'wm_10') {
    return 'Acknowledge the information above and that you will inform HASC of any changes';
  }
  if (formId === 'wm_06') {
    return 'Acknowledge that remote learning and teletherapy services will be offered';
  }
  if (!formHasStringDataEntry(formId) && formId !== 'fa_12' && formId !== 'fa_16' && formId !== 'fa_17') {
    return 'Confirm that you have read and reviewed the information above';
  }
  if (formId === 'fa_12' || formId === 'fa_16' || formId === 'fa_17') {
    return 'Confirm that you have filled this out to the best of your ability';
  }
  return 'Confirm that you have read the form and your entries are accurate';
}
